var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"narrow-container"},[_c('f-view-heading',[_c('h1',[_vm._v(_vm._s(_vm.$t('view_transaction_list.title')))])]),_c('f-transaction-list',{on:{"records-count":_vm.onRecordsCount}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }